
export const ADMIN_HOST = process.env.REACT_APP_ADMIN_HOST;
export const KEEPER_API_HOST = process.env.REACT_APP_KEEPER_API_HOST;
export const KEEPER_CLIENT_ID = process.env.REACT_APP_KEEPER_CLIENT_ID;
export const AXIOS_DEFAULTS_TIMEOUT = process.env.REACT_AXIOS_DEFAULTS_TIMEOUT;
